import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { PhonebookService } from 'rainbow-web-sdk/services/directory/phonebook.service';

export class PbxUsersPlugin extends Plugin {
    public static initialize(): PbxUsersPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[PbxUsersPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[PbxUsersPlugin] initialized");
            window.rainbow.plugins[PbxUsersPlugin.name] = new PbxUsersPlugin();
            PhonebookService.getInstance();
        }
        return window.rainbow.plugins[PbxUsersPlugin.name];
    }

    private constructor() {
        super();
    }
}
